<template>
  <a-modal
    title="巡更详情"
    :visible="visible"
    destroyOnClose
    okText="提交"
    :okButtonProps="{
      style:{
         display: 'none'
      }
    }"
    cancelText="关闭"
    width="500px"
    :maskClosable="false"
    @cancel="$emit('update:visible', false)"
  >
    <a-row>
      <a-col :span="24">
        巡更点：{{current.siteName}}
      </a-col>
      <a-col :span="24">
        巡更要求：{{current.patrolRequire}}
      </a-col>
      <a-col :span="24">
        实际巡更时间：{{current.checkTime}}
      </a-col>
      <a-col :span="24">
        经纬度：{{current.lng}}&nbsp;{{current.lat}}
      </a-col>
      <a-col :span="24">
        巡更人：{{current.name}}
      </a-col>
      <a-col :span="24">
        巡更结果：{{handleIsHg(current.isHg)}}
      </a-col>
      <a-col :span="24">
        <picture-card :fileList="fileList" isPreview/>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>

export default {
  name: 'DialogPatrolLogSiteDetail',

  props: {
    visible: Boolean,
    current: Object
  },

  computed: {
    fileList () {
      return this.current.imgs ? this.current.imgs.split(',') : ''
    }
  },

  data () {
    return {
      loading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: []
    }
  },

  methods: {
    handleIsHg (value) {
      return typeof (value) === 'undefined' ? '' : value ? '正常' : '异常'
    }
  }
}
</script>

<style lang="less" scoped>
</style>
